import { Directive, ElementRef, Input, Inject, PLATFORM_ID, Renderer2, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: 'img[lazyLoad]'
})
export class UniversalLazyImageDirective implements OnInit {
  @Input() lazyLoad: string = '';
  @Input() defaultImage: string = '';
  @Input() errorImage: string = '';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      // Client: keep using ng-lazyload-image
      this.renderer.setAttribute(this.el.nativeElement, 'lazyLoad', this.lazyLoad);
    } else {
      // Server: set src directly
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.lazyLoad || this.defaultImage);
    }
  }
}
